import { render, staticRenderFns } from "./EmailCode.vue?vue&type=template&id=478c8438&scoped=true"
import script from "./EmailCode.vue?vue&type=script&lang=js"
export * from "./EmailCode.vue?vue&type=script&lang=js"
import style0 from "./EmailCode.vue?vue&type=style&index=0&id=478c8438&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "478c8438",
  null
  
)

export default component.exports